import { convertForPdfLayoutProps } from '../utils';
import axios from 'axios';
export const pdfRender = async (arg) => {
    try {
        const { page, schema, pdfDoc, options } = arg;
        const measurementPointId = Number(schema.appRender.measurementPoint);
        const { measurementPoints } = options;
        const measurementPoint = measurementPoints.find(mp => mp.id === measurementPointId);
        if (!measurementPoint) {
            throw new Error(`MeasurementPoint mit ID ${measurementPointId} nicht gefunden.`);
        }
        const { measurements, norm, maxN } = measurementPoint;
        const pageHeight = page.getHeight();
        const { height, width, position } = convertForPdfLayoutProps({ schema, pageHeight });
        const { x, y } = position;
        const response = await axios.post('https://vgkesm6t1j.execute-api.eu-central-1.amazonaws.com/prod/chart', {
            measurements: JSON.stringify(measurements),
            norm: norm,
            maxN: maxN,
            width: width,
            height: height
        }, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const allImage = await pdfDoc.embedPng(response.data.image);
        page.drawImage(allImage, {
            x: x,
            y: y,
            height: height,
            width: width,
        });
    }
    catch (error) {
        console.log(error);
    }
};
//# sourceMappingURL=pdfRender.js.map